import { Application } from "@hotwired/stimulus";

import { FormController, FieldController } from "stimulus-zod-form";
import { ContactMessageSchema } from "../schema/contact_message";

const PropertyMessageController = FormController(ContactMessageSchema);

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

application.register("property-message", PropertyMessageController);
application.register("field", FieldController);

export { application };
